// Tipografía de marca: Plus Jakarta Sans (aprobada por taste-skill; reemplaza el
// Roboto por defecto). Titulares con peso alto y tracking negativo para "presencia";
// pesos 500/600 para jerarquía sutil; botones en sentence case. Las cifras tabulares
// se activan globalmente en MuiCssBaseline (ver components.js) para alinear datos.
const FONT_FAMILY = [
  '"Plus Jakarta Sans"',
  '"Roboto"',
  '"Helvetica"',
  '"Arial"',
  'sans-serif'
].join(', ');

const typography = {
  fontFamily: FONT_FAMILY,
  h1: { fontWeight: 800, letterSpacing: '-0.022em' },
  h2: { fontWeight: 800, letterSpacing: '-0.02em' },
  h3: { fontWeight: 800, letterSpacing: '-0.018em' },
  h4: { fontWeight: 700, letterSpacing: '-0.012em' },
  h5: { fontWeight: 700, letterSpacing: '-0.01em' },
  h6: { fontWeight: 700, letterSpacing: '-0.005em' },
  subtitle1: { fontWeight: 600 },
  subtitle2: { fontWeight: 600 },
  button: { fontWeight: 600, textTransform: 'none', letterSpacing: 0 }
};

export default typography;
